"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _analytics = require("../../analytics");
var _questionnaireActions = require("../../../store/questionnaire/questionnaireActions");
var _uiActions = require("../../../store/ui/uiActions");
var _recommendationActions = require("../../../store/recommendation/recommendationActions");
var _appActions = require("../../../store/appActions");
var _constants = require("../../../utils/constants");
class AnalyticsServiceSA extends _analytics.AnalyticsService {
  constructor(config) {
    super(config);
    this.questionsAnswers = [];
  }
  startJourney() {
    console.log('South Africa Journey started ....');
  }
  _getSliderSelectedLabels(_ref) {
    let {
      selectedTargetPoints,
      currentQuestion
    } = _ref;
    const selectedLabels = [];
    let value;
    selectedTargetPoints.map((point, index) => {
      var _currentQuestion$mult, _currentQuestion$mult2, _currentQuestion$mult3;
      value = currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$mult = currentQuestion.multi[index].rangeChoices) === null || _currentQuestion$mult === void 0 ? void 0 : (_currentQuestion$mult2 = _currentQuestion$mult.labels) === null || _currentQuestion$mult2 === void 0 ? void 0 : (_currentQuestion$mult3 = _currentQuestion$mult2.find(item => item.value === point)) === null || _currentQuestion$mult3 === void 0 ? void 0 : _currentQuestion$mult3.label;
      if (value) {
        selectedLabels.push(value);
      }
    });
    return selectedLabels;
  }
  _composeTaggingActionEvent(_ref2) {
    var _currentQuestion$tagg;
    let {
      currentQuestion,
      stepName,
      eventName
    } = _ref2;
    if (eventName === 'onToolBack') {
      return {};
    }
    const answers = {};
    const selections = currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg === void 0 ? void 0 : _currentQuestion$tagg.selections;
    const lastAnswer = this.questionsAnswers[stepName];
    if (Array.isArray(selections) && lastAnswer !== null && lastAnswer !== void 0 && lastAnswer.length) {
      const selectedLabels = this._getSliderSelectedLabels({
        selectedTargetPoints: lastAnswer,
        currentQuestion
      });
      for (let i = 0; i < (selections === null || selections === void 0 ? void 0 : selections.length); i++) {
        answers[selections[i]] = selectedLabels[i];
      }
    } else {
      var _this$questionsAnswer, _this$questionsAnswer2;
      ((_this$questionsAnswer = this.questionsAnswers) === null || _this$questionsAnswer === void 0 ? void 0 : _this$questionsAnswer[stepName]) && (answers[selections] = (_this$questionsAnswer2 = this.questionsAnswers[stepName]) === null || _this$questionsAnswer2 === void 0 ? void 0 : _this$questionsAnswer2.join(' | '));
    }
    return answers;
  }
  _composeTaggingViewEvent(_ref3) {
    var _currentQuestion$tagg2, _currentQuestion$tagg3;
    let {
      eventName,
      currentQuestion
    } = _ref3;
    switch (eventName) {
      case 'onToolView':
        return {
          page_event: 'view',
          page_name: `guided selling: step ${currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg2 = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg2 === void 0 ? void 0 : _currentQuestion$tagg2.stepNumber}: ${currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg3 = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg3 === void 0 ? void 0 : _currentQuestion$tagg3.stepName}`
        };
      case 'onToolResult':
        return {
          page_event: 'view',
          page_name: 'guided selling: step six: recommendation'
        };
      default:
        return {};
    }
  }
  _composeAnswers(_ref4) {
    let {
      eventName,
      currentQuestion,
      selectedOptionEvent,
      stepName,
      linkType
    } = _ref4;
    if (eventName === 'onToolBack') {
      return {};
    }
    if (selectedOptionEvent !== null && selectedOptionEvent !== void 0 && selectedOptionEvent.length) {
      var _this$questionsAnswer3;
      this.questionsAnswers[stepName] = selectedOptionEvent;
      const lastAnswer = (_this$questionsAnswer3 = this.questionsAnswers[stepName]) === null || _this$questionsAnswer3 === void 0 ? void 0 : _this$questionsAnswer3.join(' | ');
      if (eventName === 'onToolAnswer' && (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.type) === 'choices' && lastAnswer) {
        var _currentQuestion$tagg4;
        return {
          link_type: linkType,
          link_name: `guided selling: ${currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg4 = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg4 === void 0 ? void 0 : _currentQuestion$tagg4.stepName}: ${lastAnswer}`
        };
      }
    }
  }
  _handleFloaterTagging(eventPayload, linkType) {
    let linkNameAction;
    if (eventPayload === _constants.FLOATER_CLOSED_EVENTS.CLOSED_BY_ICON) {
      linkNameAction = 'cancel';
    } else if (eventPayload === _constants.FLOATER_CLOSED_EVENTS.CLOLSED_BY_BTN) {
      linkNameAction = 'not now';
    }
    return linkNameAction ? {
      link_type: linkType,
      link_name: `guided selling: help me decide: ${linkNameAction}`
    } : null;
  }
  _ignoreEvent(_ref5) {
    let {
      eventName,
      selectedOptionEvent,
      currentQuestion,
      actionType,
      areRecommendationSpecsVisible,
      floaterCloseTagging,
      isExclusiveSelection
    } = _ref5;
    if (eventName === 'onFloaterClose' && !floaterCloseTagging || !areRecommendationSpecsVisible && eventName === 'onOpenedRecommendationSpecs' || (actionType === _questionnaireActions.REPLACE_SELECTION || actionType === _questionnaireActions.REMOVE_SELECTION) && ((currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.type) === 'multi' || (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.type) === 'search') && selectedOptionEvent !== null && selectedOptionEvent !== void 0 && selectedOptionEvent.length || eventName === 'onToolAnswer' && (!(selectedOptionEvent !== null && selectedOptionEvent !== void 0 && selectedOptionEvent.length) || currentQuestion.id === _constants.QUESTION_ID.BUDGET) || isExclusiveSelection && (actionType === _questionnaireActions.REPLACE_SELECTION || actionType === _questionnaireActions.REMOVE_SELECTION)) {
      return true;
    }
  }
  _capitalize(text) {
    return text && text.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
  }
  _getTaggingType(_ref6) {
    let {
      type,
      stepName
    } = _ref6;
    return {
      taggingId: `${this.TAGGING_ID_PREFIX}_${stepName}`,
      taggingType: type
    };
  }
  composeTaggingEvents(_ref7) {
    var _currentQuestion$tagg5, _currentQuestion$tagg6, _currentQuestion$tagg7, _currentQuestion$tagg8, _currentQuestion$tagg9;
    let {
      pageName,
      eventName,
      selectedOptionEvent,
      currentQuestion,
      currentProduct,
      eventPayload,
      actionType,
      areRecommendationSpecsVisible,
      isExclusiveSelection
    } = _ref7;
    const stepName = currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg5 = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg5 === void 0 ? void 0 : _currentQuestion$tagg5.stepName;
    const linkType = 'o';
    const floaterCloseTagging = this._handleFloaterTagging(eventPayload, linkType);
    const isIgnoreEvent = this._ignoreEvent({
      eventName,
      selectedOptionEvent,
      currentQuestion,
      eventPayload,
      actionType,
      areRecommendationSpecsVisible,
      floaterCloseTagging,
      isExclusiveSelection
    });
    if (isIgnoreEvent) {
      return {};
    }
    const eventViewTag = this._getTaggingType({
      type: 'view',
      stepName
    });
    const eventActionTag = this._getTaggingType({
      type: 'link',
      stepName
    });
    return {
      onFloaterOpen: {
        ...eventActionTag,
        link_type: linkType,
        link_name: 'guided selling: help me decide'
      },
      onFloaterClose: {
        ...eventActionTag,
        ...floaterCloseTagging
      },
      onToolStart: {
        ...eventActionTag,
        link_type: linkType,
        link_name: 'guided selling: help me decide: get started'
      },
      onToolView: {
        ...eventViewTag,
        ...this._composeTaggingViewEvent({
          eventName,
          currentQuestion
        })
      },
      onToolAnswer: {
        ...eventActionTag,
        ...this._composeAnswers({
          eventName,
          currentQuestion,
          selectedOptionEvent,
          stepName,
          linkType
        })
      },
      onToolNext: {
        ...eventActionTag,
        link_type: linkType,
        link_name: `guided selling: ${currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg6 = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg6 === void 0 ? void 0 : _currentQuestion$tagg6.stepName}: next`,
        ...this._composeTaggingActionEvent({
          currentQuestion,
          stepName,
          eventName
        })
      },
      onToolBack: {
        ...eventActionTag,
        link_type: linkType,
        link_name: `guided selling: ${currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg7 = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg7 === void 0 ? void 0 : _currentQuestion$tagg7.stepName}: back`
      },
      onToolRestart: {
        ...eventActionTag,
        link_type: linkType,
        link_name: `guided selling: ${currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg8 = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg8 === void 0 ? void 0 : _currentQuestion$tagg8.stepName}: restart`
      },
      onToolResult: {
        ...eventViewTag,
        taggingId: `${this.TAGGING_ID_PREFIX}_recommendation`,
        ...this._composeTaggingViewEvent({
          eventName,
          currentQuestion
        })
      },
      onToolCompare: {
        ...eventActionTag,
        taggingId: `${this.TAGGING_ID_PREFIX}_compare`,
        link_type: linkType,
        link_name: 'guided selling: recommendation: compare devices'
      },
      onToolClose: {
        ...eventActionTag,
        taggingId: `${this.TAGGING_ID_PREFIX}_cancel`,
        link_type: linkType,
        link_name: pageName === 'questionnaire' ? `guided selling: ${currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg9 = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg9 === void 0 ? void 0 : _currentQuestion$tagg9.stepName}: cancel` : 'guided selling: recommendation: cancel'
      },
      onToolResultTabSwitch: {
        ...eventActionTag,
        taggingId: `${this.TAGGING_ID_PREFIX}_recommendation`,
        link_type: linkType,
        link_name: 'guided selling: recommendation',
        GS_device_option: (currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.tier) === _constants.RECOMMENDATION_TIER.RECOMMENDED ? 'Best Match' : this._capitalize(currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.tier)
      },
      onToolCheckout: {
        ...eventActionTag,
        link_type: linkType,
        link_name: 'guided selling: recommendation: next',
        GS_recommendation: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.productName,
        GS_device_option: (currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.tier) === _constants.RECOMMENDATION_TIER.RECOMMENDED ? 'Best Match' : this._capitalize(currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.tier),
        GS_sale_flag: currentProduct !== null && currentProduct !== void 0 && currentProduct.onlineDiscountPriceAlteration ? true : false
      },
      onToolBackRecommendation: {
        ...eventActionTag,
        link_type: linkType,
        link_name: 'guided selling: recommendation: back arrow'
      },
      onOpenedRecommendationSpecs: {
        ...eventActionTag,
        link_type: linkType,
        link_name: 'guided selling: recommendation: show full specifications'
      },
      onReopenRecommendation: {
        ...eventViewTag,
        link_type: linkType,
        link_name: 'guided selling: view my recommendations'
      },
      onGoBackToQuestion: {
        ...eventActionTag,
        link_type: linkType,
        link_name: 'guided selling: recommendation: back arrow'
      }
    };
  }
  getEventsName() {
    return {
      [_uiActions.OPEN_FLOATER]: {
        eventName: 'onFloaterOpen'
      },
      [_uiActions.CLOSE_FLOATER]: {
        eventName: 'onFloaterClose'
      },
      [_uiActions.OPEN_GUIDED_SELLING_MODAL]: {
        eventName: 'onToolStart'
      },
      [_uiActions.CLOSE_GUIDED_SELLING_MODAL]: {
        eventName: 'onToolClose'
      },
      [_questionnaireActions.SET_VIEW_QUESTION_TAGS]: {
        eventName: 'onToolView'
      },
      [_questionnaireActions.GOTO_NEXT_QUESTION]: {
        eventName: 'onToolNext'
      },
      [_questionnaireActions.GOTO_PREVIOUS_QUESTION]: {
        eventName: 'onToolBack'
      },
      [_questionnaireActions.RESET_QUESTIONNAIRE]: {
        eventName: 'onToolRestart'
      },
      [_questionnaireActions.ADD_SELECTION]: {
        eventName: 'onToolAnswer'
      },
      [_questionnaireActions.REPLACE_SELECTION]: {
        eventName: 'onToolAnswer'
      },
      [_questionnaireActions.REMOVE_SELECTION]: {
        eventName: 'onToolAnswer'
      },
      [_recommendationActions.FETCH_RECOMMENDATION_SUCCESS]: {
        eventName: 'onToolResult'
      },
      [_recommendationActions.GO_TO_COMPARISON_PAGE]: {
        eventName: 'onToolCompare'
      },
      [_recommendationActions.UPDATE_SELECTED_HANDSET]: {
        eventName: 'onToolResultTabSwitch'
      },
      [_appActions.CHECKOUT]: {
        eventName: 'onToolCheckout'
      },
      [_recommendationActions.SET_ARE_RECOMMENDATION_SPECS_VISIBLE]: {
        eventName: 'onOpenedRecommendationSpecs'
      },
      [_recommendationActions.REOPEN_RECOMMENDATION]: {
        eventName: 'onReopenRecommendation'
      },
      [_recommendationActions.GO_BACK_TO_QUESTIONNAIRE]: {
        eventName: 'onGoBackToQuestion'
      }
    };
  }
}
var _default = AnalyticsServiceSA;
exports.default = _default;